(() => {
  if (window.skShoeCarouselLoaded) return;
  window.skShoeCarouselLoaded = true;
  const initialized = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    root.querySelectorAll('[data-sk-shoe-carousel]').forEach((carousel) => {
      if (initialized.has(carousel)) return;
      initialized.add(carousel);

      const track = carousel.querySelector('[data-carousel-track]');
      if (!track) return;
      const step = () => {
        const item = track.querySelector('.sk-shoe-carousel__item');
        if (!item) return 0;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      };
      const move = (direction) => track.scrollBy({ left: direction * step(), behavior: reducedMotion.matches ? 'auto' : 'smooth' });

      carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => move(1));

      if (carousel.dataset.autoplay !== 'true') return;
      let paused = false;
      let lastInteraction = 0;
      carousel.addEventListener('pointerenter', () => { paused = true; });
      carousel.addEventListener('pointerleave', () => { paused = false; });
      carousel.addEventListener('focusin', () => { paused = true; });
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) paused = false;
      });
      carousel.addEventListener('pointerdown', () => { lastInteraction = Date.now(); }, { passive: true });
      track.addEventListener('scroll', () => { lastInteraction = Date.now(); }, { passive: true });

      const timer = window.setInterval(() => {
        if (paused || document.hidden || reducedMotion.matches || window.Shopify?.designMode || Date.now() - lastInteraction < 6000) return;
        if (track.scrollWidth <= track.clientWidth + 2) return;
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 3) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          move(1);
        }
      }, 5000);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(carousel)) window.clearInterval(timer);
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
